import { useCallback } from 'react';
import { GridApi, RowGroupOpenedEvent } from 'ag-grid-community';
import { LABEL_COLUMN_ID } from './constants';

const OPENED_ROW_LABEL_WIDTH = 600;
const CLOSED_ROW_LABEL_WIDTH = 350;

const isAnyRowGroupOpen = (api: GridApi) => {
  let isAnyOpen = false;
  api.forEachNode(node => {
    if (node.expanded) {
      isAnyOpen = true;
    }
  });
  return isAnyOpen;
};

export const useColumnResizeOnGroupToggle = () => {
  const onRowGroupOpened = useCallback(({ api }: RowGroupOpenedEvent) => {
    if (isAnyRowGroupOpen(api)) {
      api.applyColumnState({
        state: [
          {
            colId: LABEL_COLUMN_ID,
            width: OPENED_ROW_LABEL_WIDTH,
          },
        ],
      });
    } else {
      api.applyColumnState({
        state: [
          {
            colId: LABEL_COLUMN_ID,
            width: CLOSED_ROW_LABEL_WIDTH,
          },
        ],
      });
    }
  }, []);

  return {
    onRowGroupOpened,
  };
};


